import { render, staticRenderFns } from "./DetalleProtesis.vue?vue&type=template&id=783a7323&scoped=true"
import script from "./DetalleProtesis.vue?vue&type=script&lang=js"
export * from "./DetalleProtesis.vue?vue&type=script&lang=js"
import style0 from "./DetalleProtesis.vue?vue&type=style&index=0&id=783a7323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783a7323",
  null
  
)

export default component.exports